import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import * as api from "../../../api";
import ProductItem from "../../components/product/user_product_item";
import { subscriptions } from "../../../api/product";
import { setProductPlans } from "../../../redux/actions/productPlans_actions";
import { cancelBussinessAccount } from "../../../api/bussiness";
import { useUserStore } from "../../../store/user_store";
import { useEffectOnce, useLocation } from "react-use";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useCallback } from "react";

// Status tab config
const statusTabs = [
    { key: "active", label: "Активные", color: "emerald", icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    )},
    { key: "inactive", label: "Неактивные", color: "amber", icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
    )},
    { key: "moderation", label: "Модерация", color: "blue", icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    )},
    { key: "disabled", label: "Отключенные", color: "slate", icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="9" y1="9" x2="15" y2="15" />
            <line x1="15" y1="9" x2="9" y2="15" />
        </svg>
    )},
];

const colorMap = {
    emerald: {
        active: "bg-emerald-500 text-white shadow-md shadow-emerald-500/20",
        inactive: "bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-100",
    },
    amber: {
        active: "bg-amber-500 text-white shadow-md shadow-amber-500/20",
        inactive: "bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100",
    },
    blue: {
        active: "bg-blue-500 text-white shadow-md shadow-blue-500/20",
        inactive: "bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100",
    },
    slate: {
        active: "bg-slate-500 text-white shadow-md shadow-slate-500/20",
        inactive: "bg-slate-50 text-slate-600 border border-slate-200 hover:bg-slate-100",
    },
};

const ProfilePage = () => {
    const dispatch = useDispatch()
    const auth = useUserStore()
    const location = useLocation()
    const user = auth.user
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const limit = 20
    const [offset, setOffset] = useState(0)
    const tab = useMemo(() => {
        if (location.hash) {
            return location.hash.replace('#', '')
        }
        return 'active'
    }, [location])

    const fetchPlans = async () => {
        const plans = await subscriptions()
        if (plans != null) {
            dispatch(setProductPlans(plans))
        }
    }
    const fetchProducts = async () => {
        setIsLoading(true)
        let data = await api.fetchUserProducts({ status: tab })
        if (data != null) {
            setProducts(data)
            setOffset(offset + limit)
        }
        setIsLoading(false)
    }
    const cancelBusiness = async () => {
        const cancel = await cancelBussinessAccount()

        setTimeout(() => {
            window.location.href = `/profile`
        }, 1200)
    }

    useEffectOnce(() => {
        document.title = "Мои объявления"

        fetchPlans()
        auth.fetchUser()
    });

    useEffect(() => {
        fetchProducts();
    }, [tab])

    return (
        <div className="px-2 sm:px-0">
            {/* Status Tabs — Scrollable on mobile */}
            <div className="overflow-x-auto scrollbar-hide -mx-2 px-2 sm:mx-0 sm:px-0 pt-2 sm:pt-0">
                <div className="flex gap-2 sm:gap-3 min-w-max sm:min-w-0 sm:flex-wrap">
                    {statusTabs.map((item) => (
                        <Link
                            key={item.key}
                            to={`/profile/list#${item.key}`}
                            className={classNames(
                                "flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 whitespace-nowrap active:scale-95",
                                tab === item.key
                                    ? colorMap[item.color].active
                                    : colorMap[item.color].inactive
                            )}
                        >
                            <span className="flex-shrink-0">{item.icon}</span>
                            <span>{item.label}</span>
                        </Link>
                    ))}
                </div>
            </div>

            {/* Products Grid */}
            {isLoading ? (
                <div className="flex flex-col items-center justify-center py-16">
                    <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin" />
                    <p className="mt-4 text-sm text-slate-400 font-medium">Загрузка...</p>
                </div>
            ) : products.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-4">
                    <div className="w-16 h-16 bg-slate-50 rounded-2xl flex items-center justify-center mb-4">
                        <svg className="w-8 h-8 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                        </svg>
                    </div>
                    <h3 className="text-base font-semibold text-slate-700 mb-1">Нет объявлений</h3>
                    <p className="text-sm text-slate-400 text-center">У вас пока нет объявлений в этой категории</p>
                </div>
            ) : (
                <div className="mt-4 sm:mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    {products.map((product, index) => (
                        <div key={product.id || index}>
                            <ProductItem
                                product={product}
                                index={index}
                                onEdit={() => {
                                    window.location.href = `/edit/${product.id}`
                                }}
                                onDelete={() => {
                                    window.location.href = `/delete/${product.id}`
                                }}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ProfilePage;